import HeroBg from "public/netWorkNums/network_ NMS.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Compare Our Plans",
    link: "comparison",
  },
  button2: {
    label: "Design Your Observability Pipeline",
    link: "contact-us",
  },
  title: "Complete Network Visibility for Proactive Management",
  desc: "End-to-end network visibility for faster issue resolution, smarter insights, and proactive performance management.",
  image: HeroBg,
};
